import React from 'react';
import ReactDOM from 'react-dom/client';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const options = { 'client-id': process.env.REACT_APP_PAYPAL_CLIENT_ID, components: 'buttons' };

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PayPalScriptProvider options={options} deferLoading={true}>
      <App />
    </PayPalScriptProvider>
  </React.StrictMode>
);

reportWebVitals();